import JustValidate from 'just-validate';
import {
	birthdateRules,
	emailRules,
	getErrorContainer,
	nameRules,
} from '../../assets/scripts/utils/validationRules';

class Order {
	constructor() {
		this.init();
	}

	init() {
		this.container = document.querySelector('[data-order]');

		if (!this.container) {
			return;
		}

		this.shipmentChosen =
			this.container.querySelector('[name="shipment-chosen"]')?.value ===
			'true';

		this._initHiddenSections();
		this._initBonus();
		this._initBuyerValidation();
		this._initReceiverValidation();
	}
	_initHiddenSections() {
		const toggles = this.container.querySelectorAll('[data-switcher]');

		toggles.forEach((toggle) => {
			const checkbox = toggle.querySelector('input[type="checkbox"]');
			const id = toggle.getAttribute('data-switcher');
			const section = document.querySelector(`#${id}`);

			if (!section) {
				return;
			}

			const sectionInputs = section.querySelectorAll('input');
			const onChecked = () => {
				section.hidden = !checkbox.checked;
				sectionInputs.forEach((input) => {
					input.disabled = !checkbox.checked;

					if (input.iti) {
						input.iti.setDisabled(!checkbox.checked);
					}
				});
			};

			checkbox.addEventListener('change', onChecked);
			onChecked();
		});
	}
	_initBonus() {
		const wrapper = this.container.querySelector('.order__bonus');

		if (!wrapper) {
			return;
		}

		const bonusInput = wrapper.querySelector('[data-input]');
		const presetButtons = wrapper.querySelectorAll('[data-bonus-value]');

		presetButtons.forEach((button) => {
			button.addEventListener('click', () => {
				bonusInput?.customInput.setValue(
					Number(button.getAttribute('data-bonus-value')),
				);
			});
		});
	}
	_initBuyerValidation() {
		const form = document.querySelector('[data-popup="buyer"] .popup__form');
		const inputs = {
			surname: form.querySelector('#buyer-surname'),
			name: form.querySelector('#buyer-name'),
			tel: form.querySelector('#buyer-tel'),
			email: form.querySelector('#buyer-email'),
			birthdate: form.querySelector('#buyer-birthdate'),
		};
		const submitButton = form.querySelector('[type="submit"]');

		const validator = new JustValidate(form, {
			validateBeforeSubmitting: true,
		});

		form.validator = validator;

		validator
			.addField(inputs.surname, nameRules, {
				errorsContainer: getErrorContainer(inputs.surname),
			})
			.addField(inputs.name, nameRules, {
				errorsContainer: getErrorContainer(inputs.name),
			})
			.addField(
				inputs.tel,
				[
					{
						rule: 'required',
						errorMessage: 'Обязательное поле',
					},
					{
						validator: (value, context) => {
							return (
								value.replace(/\D/g, '').length >
								context[3].elem.placeholder.replace(/\D/g, '').length - 1
							);
						},
						errorMessage: 'Неверный формат',
					},
				],
				{
					errorsContainer: getErrorContainer(inputs.tel),
				},
			)
			.addField(inputs.email, emailRules, {
				errorsContainer: getErrorContainer(inputs.email),
			})
			.addField(inputs.birthdate, birthdateRules, {
				errorsContainer: getErrorContainer(inputs.birthdate),
			})
			.onValidate(({ isValid }) => {
				submitButton.disabled = !isValid;
			});
	}
	_initReceiverValidation() {
		const form = document.querySelector('[data-order]');
		const inputs = {
			checkbox: form.querySelector('[data-switcher="receiver-not-me"] input'),
			surname: form.querySelector('#receiver-surname'),
			name: form.querySelector('#receiver-name'),
			tel: form.querySelector('#receiver-tel'),
		};
		const submitButton = form.querySelector('[type="submit"]');

		const validator = new JustValidate(form, {
			validateBeforeSubmitting: true,
		});

		form.validator = validator;
		form.validator.isValid = true;
		submitButton.disabled = !form.validator.isValid || !this.shipmentChosen;

		const onChecked = () => {
			if (inputs.checkbox.checked) {
				form.validator.isValid = false;
				validator
					.addField(inputs.surname, nameRules, {
						errorsContainer: getErrorContainer(inputs.surname),
					})
					.addField(inputs.name, nameRules, {
						errorsContainer: getErrorContainer(inputs.name),
					})
					.addField(
						inputs.tel,
						[
							{
								rule: 'required',
								errorMessage: 'Обязательное поле',
							},
							{
								validator: (value, context) => {
									return (
										value.replace(/\D/g, '').length >
										context[3].elem.placeholder.replace(/\D/g, '').length - 1
									);
								},
								errorMessage: 'Неверный формат',
							},
						],
						{
							errorsContainer: getErrorContainer(inputs.tel),
						},
					)
					.onValidate(({ isValid }) => {
						submitButton.disabled = !isValid || !this.shipmentChosen;
					});

				validator.hasFields = true;
			} else {
				if (validator.hasFields) {
					validator
						.removeField(inputs.surname)
						.removeField(inputs.name)
						.removeField(inputs.tel);
					validator.hasFields = false;
				}

				form.validator.isValid = true;
			}

			form.validator.validate();
			submitButton.disabled = !form.validator.isValid || !this.shipmentChosen;
		};

		inputs.checkbox.addEventListener('change', onChecked);
		onChecked();
	}
}

export default new Order();
